<template>
  <div style="width: 800px">
    <label style="font-weight: bold; font-size: 18px">
      Activities
    </label>
    <br />
    <p>What activities do you do, and what extra things do you bring?</p>

    <el-form @submit.native.prevent>
      <el-form-item :required="true">
        <div class="ts-comp--multiselect columned">
          <div class="ts-comp--multiselect-item hide-sm">
            <label role="title">&nbsp;</label>
            <div class="cols">
              <span>
                <img
                  src="~../../../../assets/img/icons/outsiderole_icon.svg"
                  alt="I add to role"
                />
                <strong>I add to role</strong>
              </span>
            </div>
          </div>
          <div
            v-for="(activity, index) in workActivities"
            :key="`activity-${index}`"
            class="ts-comp--multiselect-item"
          >
            <label>
              {{ checkIfContainsOrganization(activity.activity) }}
            </label>
            <div class="cols">
              <span>
                <el-checkbox
                  @change="
                    v => handleKnowledgeChange(activity.activity, 'IN', v)
                  "
                  v-model="knowledgeRegularlyUsed[activity.activity].in"
                ></el-checkbox>
              </span>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <el-alert
      v-if="ActivitiesError"
      :title="ActivitiesError"
      type="error"
      :closable="false"
    ></el-alert>
    <button
      class="ts-btn ts-btn-rounded ts-btn-secondary"
      @click="storeSection()"
    >
      Continue
    </button>
    <br />
    <a class="back-link" @click="goBack">
      <i class="fas fa-chevron-left"></i>Back
    </a>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
export default {
  created() {
    this.locale = localStorage.getItem("locale");
    this.fetchSession();

    if (
      this.currentCriteria.sgaHiddenExtras != null &&
      this.currentCriteria.sgaHiddenExtras.workingPracticeActivities !=
        undefined
    ) {
      this.sgaHiddenExtras = this.currentCriteria.sgaHiddenExtras;
    }

    this.$store.dispatch("onet/workActivities", "15-1132.00").then(res => {
      const mappedActivities = res.map(activity => {
        const activitySelection = this.sgaHiddenExtras
          .workingPracticeActivities[activity];
        return {
          checked: activitySelection !== undefined,
          rating:
            activitySelection !== undefined ? activitySelection.rating : 0,
          activity,
          value: null
        };
      });

      this.$store
        .dispatch("sga/setWorkActivities", mappedActivities)
        .then(() => {
          this.isLoading = true;
          this.mapToCurrentActivities(
            this.sgaHiddenExtras.workingPracticeActivities
          );
          this.isLoading = false;
        });
    });
  },
  destroyed() {},
  data() {
    return {
      sgaHiddenExtras: {
        workingPracticeActivities: []
      },
      ActivitiesError: null,
      locale: null
    };
  },
  watch: {},
  computed: {
    currentCriteria() {
      return this.$store.state.apprentice.current_apprentice_criteria;
    },
    workActivities() {
      return this.$store.state.sga.workActivities;
    },
    knowledgeRegularlyUsed: {
      get() {
        if (this.isLoading) return {};
        return Object.assign(
          {},
          ...Object.entries({
            ...this.workActivities.map(v => v.activity)
          }).map(an => {
            let oo = null;
            try {
              const fid = this.sgaHiddenExtras.workingPracticeActivities.find(
                wpa => wpa.selection === an[1]
              );
              if (fid) oo = fid;
            } catch (error) {}
            return {
              [an[1]]: {
                name: an[1],
                in: oo && oo.value.includes("IN"),
                out: oo && oo.value.includes("OUT")
              }
            };
          })
        );
      },
      set(v) {
        console.log(v);
      }
    }
  },
  methods: {
    fetchSession() {
      var parsed = JSON.parse(window.sessionStorage.getItem("currentCriteria"));
      if (parsed != null) {
        this.currentCriteria.id = parsed.id;
        this.currentCriteria.subjectArea = parsed.subjectArea;
        this.currentCriteria.level = parsed.level;
        this.currentCriteria.pathway = parsed.pathway;
        this.currentCriteria.sgaHiddenExtras =
          parsed.sgaHiddenExtras == null ? null : parsed.sgaHiddenExtras;
        this.currentCriteria.sgaKnowledge =
          parsed.sgaKnowledge == null ? null : parsed.sgaKnowledge;
        this.currentCriteria.sgaSkills =
          parsed.sgaSkills == null ? null : parsed.sgaSkills;
        this.currentCriteria.sgaMindset =
          parsed.sgaMindset == null ? null : parsed.sgaMindset;
      }
    },
    storeSection() {
      //client side validation, initial records should not save in DB
      if (this.sgaHiddenExtras.workingPracticeActivities.length == 0) {
        this.ActivitiesError = "Please select at least 1 activity.";
        return false;
      } else {
        this.ActivitiesError = null;
      }
      this.currentCriteria.sgaHiddenExtras = this.sgaHiddenExtras;
      window.sessionStorage.setItem(
        "currentCriteria",
        JSON.stringify(this.currentCriteria)
      );
      this.$router.app.$emit("navigateToNextStep");
    },
    goBack() {
      this.$router.back();
    },
    handleKnowledgeChange(obj, val, a) {
      let oo = null;

      try {
        const fid = this.sgaHiddenExtras.workingPracticeActivities.findIndex(
          (wpa) => wpa.selection === obj
        );
        if (fid !== -1) oo = fid;
      } catch (error) {}

      if (oo == null) {
        this.sgaHiddenExtras.workingPracticeActivities.push({
          selection: obj,
          value: `${val}`
        });
      } else {
        const v = this.sgaHiddenExtras.workingPracticeActivities[oo];
        if (v.value.includes(val)) {
          // remove val from string
          v.value = v.value.replace(val, "");
        } else {
          // add val to string
          v.value = `${v.value}${val}`;
        }
        if (v.value === "")
          delete this.sgaHiddenExtras.workingPracticeActivities[oo];
        this.sgaHiddenExtras.workingPracticeActivities = this.sgaHiddenExtras.workingPracticeActivities.filter(
          Boolean
        );
      }
    },
    mapToCurrentActivities(v) {
      if (typeof v === "object") return;
      const nn = {};
      v.forEach(oc => {
        //   nn[oc.Selection] = { in: oc.Value.includes('IN'), out: oc.Value.includes('OUT') };
        nn[oc.Selection] = { in: oc.Value.includes("IN") };
      });

      this.$set(this.sgaHiddenExtras, "WorkingPracticeActivities", nn);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    checkIfContainsOrganization(val) {
      var str = val;
      var isTrue = false;
      if (this.locale == "en-uk") {
        isTrue = str.includes("Organization");
        if (isTrue) {
          var str = str.replace("Organization", "Organisation");
          isTrue = false;
        }
        isTrue = str.includes("Organizational");
        if (isTrue) {
          var str = str.replace("Organizational", "Organisational");
          isTrue = false;
        }
        isTrue = str.includes("Organizing");
        if (isTrue) {
          var str = str.replace("Organizing", "Organising");
          isTrue = false;
        }
        return str;
      } else {
        return val;
      }
    }
  }
};
</script>

<style lang="scss"></style>
